<div>
    <eup-sticky-header [backToLastPage]="backToLastPage" [showDownloadScreenshots]="shouldShowDownloadScreenshots"
        [hideContactSelection]="hideContactSelection" [isVerticalMenu]="isVerticalMenu"
        [insideContent]="isInsideContent" [showScreenshots]="shouldShowScreenshots" [showExport]="shouldShowExport">
    </eup-sticky-header>

    <div class="remote-application-container-root">
        <sl-embedded-remote-application *ngIf="descriptor" [descriptor]="descriptor"
                                        [preservedAppIds]="preservedAppIds"
                                        slCacheEnabled/>
    </div>
</div>